export default "__VITE_ASSET__Djq3kxb8__"